import initData from 'tradera/legacy/static/packages/init-data';

export default {
    BUYER_ACTIVE_ITEMS_HIDE: initData.pageSpecificData?.BUYER_ACTIVE_ITEMS_HIDE,
    BUYER_ACTIVE_ITEMS_SHOW: initData.pageSpecificData?.BUYER_ACTIVE_ITEMS_SHOW,
    ACTIVE_ITEMS_RESTART_SUMMARY:
        initData.pageSpecificData?.ACTIVE_ITEMS_RESTART_SUMMARY,
    MARK_PAID: initData.pageSpecificData?.MARK_PAID,
    SELLER_MARK_PAID: initData.pageSpecificData?.SELLER_MARK_PAID,
    SELLER_UNMARK_PAID: initData.pageSpecificData?.SELLER_UNMARK_PAID,
    MARK_SHIPPED: initData.pageSpecificData?.MARK_SHIPPED,
    UNMARK_SHIPPED: initData.pageSpecificData?.UNMARK_SHIPPED,
    DELETE_SHIPMENT: initData.pageSpecificData?.DELETE_SHIPMENT,
    SELLER_HIDE: initData.pageSpecificData?.SELLER_HIDE,
    SELLER_SHOW: initData.pageSpecificData?.SELLER_SHOW,
    UNSOLDHIDE: initData.pageSpecificData?.UNSOLDHIDE,
    UNSOLDSHOW: initData.pageSpecificData?.UNSOLDSHOW,
    UNMARK_BOOKED: initData.pageSpecificData?.UNMARK_BOOKED,
    ACTIVE_END_ITEMS: initData.pageSpecificData?.ACTIVE_END_ITEMS,
    UNSOLD_RESTART_ITEMS: initData.pageSpecificData?.UNSOLD_RESTART_ITEMS,
    BUYER_MARK_PAID: initData.pageSpecificData?.BUYER_MARK_PAID,
    BUYER_UNMARK_PAID: initData.pageSpecificData?.BUYER_UNMARK_PAID,
    BUYER_HIDE: initData.pageSpecificData?.BUYER_HIDE,
    BUYER_SHOW: initData.pageSpecificData?.BUYER_SHOW,
    REQUEST_COMBINED_SHIPPING_PRICE:
        '/api/webapi/shopping/ordercheckout/requestcombinedshippingprice'
};
